import * as React from 'react';
import * as styles from './BuyConfirmationModal.css';
import { ModalWindow } from '@cian/ui-kit';
import { ContentContainer } from './components/Content';
import { ActionsContainer } from './components/Actions';
import { Header } from './components/Header';
import { Footer } from './components/Footer';

interface IBuyConfirmationModalProps {
  title: string;
  onClose(): void;
}

export const BuyConfirmationModal = (props: IBuyConfirmationModalProps) => {
  const { title, onClose } = props;

  return (
    <ModalWindow
      open
      title={title}
      footer={<ActionsContainer />}
      onClose={onClose}
      data-testid="buy-confirmation-modal"
    >
      <div className={styles['content']}>
        <Header />

        <ContentContainer />

        <Footer />
      </div>
    </ModalWindow>
  );
};
